<template>

    <div class="back-button">
        <button v-on:click="$root.back()">
            <!-- <i class="las la-arrow-circle-left"></i> -->
            <i class="icon-base bs-arrow-left"/>
            <span>
                Voltar
            </span>
        </button>
    </div>
   
</template>

<script>
export default {
    name: 'BackButton',
    data () {
        return {
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BackButton.vue